import React from "react";
import {
  Box, SimpleGrid, FormControl, FormLabel, Select, Input, Switch, HStack, Text, FormErrorMessage,
} from "@chakra-ui/react";

const hoje = () => {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 10);
};

export const TIPOS_NOTA_DEVOLUCAO = {
  devolucao: "Devolução de venda",
  retorno_nao_entregue: "Recusa no recebimento",
};

export const marcacoesIniciais = (registro = {}, dataRecebimento = null) => ({
  tipo: registro.tipo || "devolucao",
  motivo: registro.tipo === "retorno_nao_entregue" ? registro.motivo || "" : "",
  garantia: !!registro.garantia,
  cliente_mei: !!registro.cliente_mei,
  mei_consultado_em: (registro.mei_consultado_em || "").slice(0, 10),
  data_recebimento: (registro.data_recebimento || dataRecebimento || hoje()).slice(0, 10),
});

// Na recusa o MEI não se aplica (vale para qualquer cliente) e o campo some da
// tela: validar ou enviar a marcação escondida travava os botões sem erro visível.
const meiAplica = (m) => m.tipo !== "retorno_nao_entregue" && !!m.cliente_mei;

export const errosMarcacoes = (m) => {
  const erros = {};
  if (m.tipo === "retorno_nao_entregue" && !String(m.motivo || "").trim()) {
    erros.motivo = "Informe o motivo da não entrega.";
  }
  if (meiAplica(m) && !m.mei_consultado_em) {
    erros.mei_consultado_em = "Informe a data da consulta.";
  }
  if (meiAplica(m) && m.mei_consultado_em > hoje()) {
    erros.mei_consultado_em = "A data não pode ser no futuro.";
  }
  if (!m.data_recebimento) {
    erros.data_recebimento = "Informe a data.";
  } else if (m.data_recebimento > hoje()) {
    erros.data_recebimento = "A data não pode ser no futuro.";
  }
  return erros;
};

export const payloadMarcacoes = (m) => ({
  tipo: m.tipo,
  ...(m.tipo === "retorno_nao_entregue" ? { motivo: String(m.motivo || "").trim() } : {}),
  garantia: !!m.garantia,
  cliente_mei: meiAplica(m),
  mei_consultado_em: meiAplica(m) ? m.mei_consultado_em : null,
  data_recebimento: m.data_recebimento,
});

export default function MarcacoesNotaDevolucao({ valores, onChange, erros = {}, mostrarErros = false }) {
  const set = (campo, valor) => onChange({ ...valores, [campo]: valor });
  const recusa = valores.tipo === "retorno_nao_entregue";

  return (
    <Box>
      <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={3}>
        <FormControl>
          <FormLabel fontSize="xs" color="gray.600" mb={1}>Tipo da nota</FormLabel>
          <Select size="sm" value={valores.tipo} onChange={(e) => set("tipo", e.target.value)}>
            {Object.entries(TIPOS_NOTA_DEVOLUCAO).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </Select>
        </FormControl>

        <FormControl isInvalid={mostrarErros && !!erros.data_recebimento}>
          <FormLabel fontSize="xs" color="gray.600" mb={1}>Data de recebimento da mercadoria</FormLabel>
          <Input size="sm" type="date" max={hoje()} value={valores.data_recebimento || ""}
            onChange={(e) => set("data_recebimento", e.target.value)} />
          <FormErrorMessage fontSize="xs">{erros.data_recebimento}</FormErrorMessage>
        </FormControl>

        {recusa && (
          <FormControl gridColumn={{ sm: "span 2" }} isInvalid={mostrarErros && !!erros.motivo}>
            <FormLabel fontSize="xs" color="gray.600" mb={1}>Motivo da não entrega</FormLabel>
            <Input size="sm" maxLength={200} value={valores.motivo || ""}
              placeholder="Destinatário ausente, endereço não encontrado, recusa na entrega..."
              onChange={(e) => set("motivo", e.target.value)} />
            <FormErrorMessage fontSize="xs">{erros.motivo}</FormErrorMessage>
          </FormControl>
        )}

        {!recusa && (
          <FormControl>
            <FormLabel fontSize="xs" color="gray.600" mb={1}>Garantia</FormLabel>
            <HStack h="32px">
              <Switch colorScheme="orange" isChecked={!!valores.garantia}
                onChange={(e) => set("garantia", e.target.checked)} />
              <Text fontSize="sm">{valores.garantia ? "Sim" : "Não"}</Text>
            </HStack>
          </FormControl>
        )}

        {!recusa && (
          <FormControl>
            <FormLabel fontSize="xs" color="gray.600" mb={1}>Cliente MEI</FormLabel>
            <HStack h="32px">
              <Switch colorScheme="orange" isChecked={!!valores.cliente_mei}
                onChange={(e) => set("cliente_mei", e.target.checked)} />
              <Text fontSize="sm">{valores.cliente_mei ? "Sim" : "Não"}</Text>
            </HStack>
          </FormControl>
        )}

        {!recusa && valores.cliente_mei && (
          <FormControl gridColumn={{ sm: "span 2" }} isInvalid={mostrarErros && !!erros.mei_consultado_em}>
            <FormLabel fontSize="xs" color="gray.600" mb={1}>Consulta "Optante pelo SIMEI" no Portal do Simples em</FormLabel>
            <Input size="sm" type="date" max={hoje()} value={valores.mei_consultado_em || ""}
              onChange={(e) => set("mei_consultado_em", e.target.value)} />
            <FormErrorMessage fontSize="xs">{erros.mei_consultado_em}</FormErrorMessage>
          </FormControl>
        )}
      </SimpleGrid>
    </Box>
  );
}
